// Custom localStorage utility that dispatches events for same-tab changes
export const setLocalStorageItem = (key, value) => {
    localStorage.setItem(key, value);

    // Dispatch custom event for same-tab localStorage changes
    const customEvent = new CustomEvent('customStorageChange', {
        detail: { key, newValue: value }
    });
    window.dispatchEvent(customEvent);
};

export const getLocalStorageItem = (key) => {
    return localStorage.getItem(key);
};

export const removeLocalStorageItem = (key) => {
    localStorage.removeItem(key);

    // Dispatch custom event for removal
    const customEvent = new CustomEvent('customStorageChange', {
        detail: { key, newValue: null }
    });
    window.dispatchEvent(customEvent);
};

// Clear all application-specific localStorage items
export const clearApplicationStorage = () => {
    const appKeys = [
        'selectedOption',
        'selectedCountry',
        'selectedUserId',
        'selectedModelName',
        'flexibilityDays',
        'selectedDevices',
        'modelTrainingStatus',
        'modelTrainingError',
        'dashboardAccessed'
    ];
    
    appKeys.forEach(key => {
        localStorage.removeItem(key);
        // Dispatch custom event for each removal
        const customEvent = new CustomEvent('customStorageChange', {
            detail: { key, newValue: null }
        });
        window.dispatchEvent(customEvent);
    });
    
    console.log('Application localStorage cleared');
}; 